import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../../actions/root_url';

export const updateISANo = ({salesOrderId, ISANo}, success) => {
  axios({
    method: 'PUT',
    data: { ISANo },
    url: `${ROOT_URL}v1/sale/sales-order-set-isa/${salesOrderId}`,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
  .then(res => {
    success();
  }, err => {
    alert(err);
  })
}


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/isaEdit/redux.jsx